export default "__VITE_ASSET__1a3b0e11__"